import React from "react";

export default function WarningIcon() {
  return <i className="ri-error-warning-line color-orange"></i>;
}
